import { fetchWithAuth } from "../FetchHelper";

const apiUrl = process.env.REACT_APP_API_URL;

export const GetAulaGameSummary = async (idAula: number | string) => {
    try {
        const response = await fetchWithAuth(`${apiUrl}:8061/jutge/aules/${idAula}/game-summary`);
        if (response && response.ok) {
            const data = await response.json();
            return Array.isArray(data) ? data : [];
        }
        return [];
    } catch (e) {
        console.error("Error al obtener resumen de juego del aula:", e);
        return [];
    }
};
